import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { AuthConstants } from '../constants/auth.constants';
import { AuthService } from '../services/auth.service';
import { getCookie } from '../utilities/pure-functions';

export const authInterceptor: HttpInterceptorFn = (req, next): Observable<HttpEvent<unknown>> => {
  const accessToken = getCookie(AuthConstants.keyAccessToken);
  const authService = inject(AuthService);

  if (!req.headers.get('addAuthHeader')) {
    return next(req);
  }

  req = req.clone({ headers: req.headers.delete('addAuthHeader') });

  if (!accessToken) {
    return authService.refresh().pipe(() => {
      return next(addTokenHeader(req, accessToken)).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error instanceof HttpErrorResponse && error.status === 401) {
            return handle401Error(req, next, authService);
          }
          return throwError(() => new Error(error.message));
        })
      );
    });
  }

  return next(addTokenHeader(req, accessToken)).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        return handle401Error(req, next, authService);
      }
      return throwError(() => new Error(error.message));
    })
  );
};

function handle401Error(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  request: HttpRequest<any>,
  next: HttpHandlerFn,
  authService: AuthService
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Observable<any> {
  return authService.refresh().pipe(
    switchMap(() => {
      const accessToken = getCookie(AuthConstants.keyAccessToken);
      return next(addTokenHeader(request, accessToken));
    }),
    catchError((err) => {
      return throwError(() => new Error(err));
    })
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function addTokenHeader(request: HttpRequest<any>, token: string | null): HttpRequest<any> {
  if (!token) {
    return request;
  }
  return request.clone({
    setHeaders: {
      authorization: `${token}`,
    },
  });
}
